import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { CapacidadOperativaEntry } from 'src/app/shared/entrys/capacidad-operativa.entry';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class CapacidadOperativaService implements RequestCRUD<CapacidadOperativaEntry, ResponseServiceModel> {
	private API_URL;
	private handleError: HandleError;
	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private enviromentGlobalService: EnviromentGlobalService) {
		this.handleError = httpErrorHandler.createHandleError('CapacidadOperativaService');
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/CapacidadOperativa/ObtenerPorDetalleSolicitud`, entry).pipe(
			retry(2)
		);
	}

	getMigracion(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/CapacidadOperativa/ObtenerMrgPorDetalleSolicitud`, entry).pipe(
			retry(2)
		);
	}

	getFormacionEmpleo(entry: CapacidadOperativaEntry): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/CapacidadOperativa/FormacionEmpleado`).pipe(
			retry(2)
		);
	}

	getCapacidadTecnica(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/TipoCapacidadTecnica/Get/${entry}`).pipe(
			retry(2)
		);
	}

	update(entry: CapacidadOperativaEntry): Observable<ResponseServiceModel> {
		return this.http.put<ResponseServiceModel>(`${this.API_URL}/CapacidadOperativa/${entry.capacidad_operativa_id}`, entry).pipe(
			retry(2)
		);
	}
	create(entry: CapacidadOperativaEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/CapacidadOperativa/create`, entry).pipe(
			retry(2)
		);
	}
	delete(entry: CapacidadOperativaEntry): Observable<ResponseServiceModel> {
		return this.http.delete<ResponseServiceModel>(`${this.API_URL}/CapacidadOperativa/${entry.capacidad_operativa_id}`).pipe(
			retry(2)
		);
	}

	getHostingSoftware(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/SubTipoCapacidadTecnica?Tipo_Capacidad_Tecnica_Id=${entry}`).pipe(
			retry(2)
		);
	}
}
